export default function Btn({
  children,
  onClick,
  color = "#38bdf8",
  disabled = false,
  style = {},
  size = "md",
  title,
}) {
  const sizes = { sm: "6px 12px", md: "9px 18px", lg: "14px 28px" };
  const fonts = { sm: 12, md: 13, lg: 16 };
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      style={{
        background: disabled
          ? "#1e293b"
          : `linear-gradient(135deg,${color},${color}cc)`,
        color: disabled ? "#64748b" : "#fff",
        border: "none",
        borderRadius: 8,
        padding: sizes[size] || sizes.md,
        fontSize: fonts[size] || fonts.md,
        fontFamily: "inherit",
        fontWeight: 700,
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "all .2s",
        boxShadow: disabled ? "none" : `0 4px 12px ${color}33`,
        ...style,
      }}
    >
      {children}
    </button>
  );
}
